/**
 * Optional groups on `boat_side_view.svg`. The workshop menu and the card
 * both read this list. A later piece is one `<g class="boat-…">`, one row
 * here, and a boat-schema bump. Art an old file never showed ships with
 * `defaultOn: false`.
 */
export const FITTINGS = [
  { key: 'rail', label: 'Rail', groupClass: 'boat-rail', defaultOn: true },
  { key: 'wings', label: 'Wings', groupClass: 'boat-wings', defaultOn: true },
  {
    key: 'sideWindow',
    label: 'Side window',
    groupClass: 'boat-side-window',
    defaultOn: true,
  },
] as const;

export type FittingKey = (typeof FITTINGS)[number]['key'];

/** `true` means the group is drawn. */
export type BoatFittings = Record<FittingKey, boolean>;

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

/** Every fitting at the value the previous card hard-coded. */
export function factoryFittings(): BoatFittings {
  const fittings = {} as BoatFittings;

  for (const fitting of FITTINGS) {
    fittings[fitting.key] = fitting.defaultOn;
  }

  return fittings;
}

/** A missing flag takes that fitting's `defaultOn`. Anything else is dropped. */
export function fittingsFromUnknown(value: unknown): BoatFittings {
  const raw = isRecord(value) ? value : {};
  const fittings = {} as BoatFittings;

  for (const fitting of FITTINGS) {
    const flag = raw[fitting.key];
    fittings[fitting.key] = typeof flag === 'boolean' ? flag : fitting.defaultOn;
  }

  return fittings;
}
